import type {WorkSummary} from 'api/types';
import type {TableConfiguration} from 'schema/table/types';
import {useAddMergeSuggestionAction} from '../../hooks/useAddMergeSuggestionAction';
import {Dewey} from '../../renderers';
import {MainTitlesCell} from '../../renderers/MainTitlesCell';
import {OtherTitles} from '../../renderers/table';
import {workSummaryDefaultColumns} from './columns/workSummaryDefaultColumns';
import {workTableConfig} from './workTableConfig';

/** workSummaryTableConfig with actions */
export const useWorkSummaryTableConfig =
  (): TableConfiguration<WorkSummary> => {
    const addMergeSuggestionAction = useAddMergeSuggestionAction();

    return {
      ...workTableConfig,
      defaultColumns: workSummaryDefaultColumns,
      partValueRenderers: {
        ...workTableConfig.partValueRenderers,
        mainTitles: MainTitlesCell,
        otherTitles: OtherTitles,
        dewey: Dewey,
      },
      actions: [addMergeSuggestionAction],
    };
  };

/** Without actions */
export const workSummaryTableConfig: TableConfiguration<WorkSummary> = {
  ...workTableConfig,
  defaultColumns: workSummaryDefaultColumns,
  partValueRenderers: {
    ...workTableConfig.partValueRenderers,
    mainTitles: MainTitlesCell,
    otherTitles: OtherTitles,
    dewey: Dewey,
  },
};
